// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Rubik:wght@400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: #f8f9fa;
  margin: 0;
  font-family: 'Rubik', sans-serif;
}

.diet-page {
  padding: 20px;
  text-align: center;
}

.diet-title {
  font-size: 32px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.diet-type-selector {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin: 20px 0;
}

.diet-type-selector label {
  font-size: 16px;
  font-weight: bold;
  color: #444;
}

.diet-type-selector select {
  width: 15%; 
  padding: 8px;
  font-size: 16px;
  border-radius: 5px;
  border: 1px solid #ccc;
  background-color: #fff;
  text-align: center;
}

.diet-container {
  background-color: #A5D6A7;
  padding: 13px;
  border-radius: 12px;
  max-width: 600px;
  margin: 20px auto;
  height: 350px;  
  overflow-y: auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #8BC34A;
  margin-bottom: 60px;
}

.diet-container::-webkit-scrollbar {
  width: 0px;
}

.diet-content {
  font-size: 18px;
  color: #333;
  white-space: pre-wrap;
  text-align: left;
  word-wrap: break-word;
}

.loading-spinner {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.greeting-container {
  margin-bottom: 20px;
}

.greeting-text {
  font-size: 34px;
  color: #333;
  font-weight: bold;
  margin-bottom: 10px;
}

.diet-title {
  font-size: 32px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
}

.motivational-quote {
  background-color: #E8F5E9;
  padding: 20px 40px;
  border-radius: 10px;
  margin: 15px auto;
  max-width: 600px;
  position: relative;
  font-style: italic;
  color: #1B5E20; 
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  font-size: 18px; 
  line-height: 1.6;
}

.motivational-quote p {
  margin: 0;
  padding: 0 30px;
  text-align: center;
}

.quote-icon {
  color: #4CAF50;
  font-size: 24px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.quote-icon.left {
  left: 15px;
}

.quote-icon.right {
  right: 15px;
}

.greeting-container {
  margin-bottom: 15px;
}

.diet-toggle-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0;
}

.segmented-control {
  display: flex;
  background-color: white;
  border-radius: 12px;
  overflow: hidden;
  padding: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  width: 100%;
  max-width: 430px;
}

.segment {
  flex: 1 1;
  padding: 12px 16px;
  text-align: center;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 500;
  color: #555;
  transition: all 0.2s ease-in-out;
  margin: 0 3px;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
}

.segment-active {
  flex: 1 1;
  padding: 12px 16px;
  text-align: center;
  border: none;
  background-color: #004D40;
  color: white;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 600;
  transition: all 0.2s ease-in-out;
  margin: 0 3px;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
}

.segment:focus, .segment-active:focus {
  outline: none;
}

.segment::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none;
  background-image: radial-gradient(circle, rgba(255, 255, 255, 0.4) 10%, transparent 10.01%);
  background-repeat: no-repeat;
  background-position: 50%;
  transform: scale(10, 10);
  opacity: 0;
  transition: transform 0.5s, opacity 0.8s;
}

.segment:active::after {
  transform: scale(0, 0);
  opacity: 0.3;
  transition: 0s;
}

.segment:hover:not(.segment-active) {
  background-color: rgba(0, 0, 0, 0.04);
  color: #333;
}

@media (max-width: 520px) {
  .segmented-control {
    max-width: 95%;
  }
  
  .segment, .segment-active {
    padding: 10px 8px;
    font-size: 0.85rem;
  }
}

@media (max-width: 600px) {
  .weight-update-page {
    padding: 20px 0;
    width: 90%;
    max-width: 100%;
    box-sizing: border-box;
    margin: 0 auto;
  }
  .weight-container {
    width: 90%;
    margin: 0 auto;
  }
  .diet-page {
    padding: 20px 10px;
    overflow-x: hidden;
    width: 90%;
    box-sizing: border-box;
    margin: 0 auto;
  }
  .segmented-control {
    width: 95%;
  }
  .diet-container {
    width: 100%;
    margin: 20px auto;
    margin-bottom: 60px;
  }
  .diet-type-selector select {
    width: 50%;
  }
}

.diet-date {
  color: #666;
  font-size: 0.9rem;
  margin-top: -10px;
  margin-bottom: 20px;
  font-style: italic;
}

/* .diet-content {
  white-space: pre-line;
  text-align: left;
  padding: 0 20px;
} */

.diet-html-content {
  text-align: left;
  padding: 0;
  white-space: pre-wrap;
  line-height: 1.6;
  font-weight: 500;
  font-size: 1.1rem;
}

.diet-html-content p {
  margin-bottom: 1em;
}

.diet-html-content strong {
  font-weight: bold;
}

.diet-html-content em {
  font-style: italic;
}

.diet-html-content u {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/styles/DietPage.css"],"names":[],"mappings":"AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,wCAAwC;EACxC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,qCAAqC;EACrC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;EACzC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;EAChC,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,oBAAoB;EACpB,2FAA2F;EAC3F,4BAA4B;EAC5B,wBAAwB;EACxB,wBAAwB;EACxB,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;IACf,UAAU;IACV,eAAe;IACf,sBAAsB;IACtB,cAAc;EAChB;EACA;IACE,UAAU;IACV,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,sBAAsB;IACtB,cAAc;EAChB;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;GAIG;;AAEH;EACE,gBAAgB;EAChB,UAAU;EACV,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Rubik:wght@400;700&display=swap');\n\nbody {\n  background-color: #f8f9fa;\n  margin: 0;\n  font-family: 'Rubik', sans-serif;\n}\n\n.diet-page {\n  padding: 20px;\n  text-align: center;\n}\n\n.diet-title {\n  font-size: 32px;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 20px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.diet-type-selector {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 15px;\n  margin: 20px 0;\n}\n\n.diet-type-selector label {\n  font-size: 16px;\n  font-weight: bold;\n  color: #444;\n}\n\n.diet-type-selector select {\n  width: 15%; \n  padding: 8px;\n  font-size: 16px;\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  background-color: #fff;\n  text-align: center;\n}\n\n.diet-container {\n  background-color: #A5D6A7;\n  padding: 13px;\n  border-radius: 12px;\n  max-width: 600px;\n  margin: 20px auto;\n  height: 350px;  \n  overflow-y: auto;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  border: 1px solid #8BC34A;\n  margin-bottom: 60px;\n}\n\n.diet-container::-webkit-scrollbar {\n  width: 0px;\n}\n\n.diet-content {\n  font-size: 18px;\n  color: #333;\n  white-space: pre-wrap;\n  text-align: left;\n  word-wrap: break-word;\n}\n\n.loading-spinner {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.greeting-container {\n  margin-bottom: 20px;\n}\n\n.greeting-text {\n  font-size: 34px;\n  color: #333;\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n\n.diet-title {\n  font-size: 32px;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.motivational-quote {\n  background-color: #E8F5E9;\n  padding: 20px 40px;\n  border-radius: 10px;\n  margin: 15px auto;\n  max-width: 600px;\n  position: relative;\n  font-style: italic;\n  color: #1B5E20; \n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  font-size: 18px; \n  line-height: 1.6;\n}\n\n.motivational-quote p {\n  margin: 0;\n  padding: 0 30px;\n  text-align: center;\n}\n\n.quote-icon {\n  color: #4CAF50;\n  font-size: 24px;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.quote-icon.left {\n  left: 15px;\n}\n\n.quote-icon.right {\n  right: 15px;\n}\n\n.greeting-container {\n  margin-bottom: 15px;\n}\n\n.diet-toggle-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 20px 0;\n}\n\n.segmented-control {\n  display: flex;\n  background-color: white;\n  border-radius: 12px;\n  overflow: hidden;\n  padding: 4px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  width: 100%;\n  max-width: 430px;\n}\n\n.segment {\n  flex: 1;\n  padding: 12px 16px;\n  text-align: center;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-size: 0.95rem;\n  font-weight: 500;\n  color: #555;\n  transition: all 0.2s ease-in-out;\n  margin: 0 3px;\n  border-radius: 8px;\n  position: relative;\n  overflow: hidden;\n}\n\n.segment-active {\n  flex: 1;\n  padding: 12px 16px;\n  text-align: center;\n  border: none;\n  background-color: #004D40;\n  color: white;\n  cursor: pointer;\n  font-size: 0.95rem;\n  font-weight: 600;\n  transition: all 0.2s ease-in-out;\n  margin: 0 3px;\n  border-radius: 8px;\n  position: relative;\n  overflow: hidden;\n}\n\n.segment:focus, .segment-active:focus {\n  outline: none;\n}\n\n.segment::after {\n  content: '';\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n  background-image: radial-gradient(circle, rgba(255, 255, 255, 0.4) 10%, transparent 10.01%);\n  background-repeat: no-repeat;\n  background-position: 50%;\n  transform: scale(10, 10);\n  opacity: 0;\n  transition: transform 0.5s, opacity 0.8s;\n}\n\n.segment:active::after {\n  transform: scale(0, 0);\n  opacity: 0.3;\n  transition: 0s;\n}\n\n.segment:hover:not(.segment-active) {\n  background-color: rgba(0, 0, 0, 0.04);\n  color: #333;\n}\n\n@media (max-width: 520px) {\n  .segmented-control {\n    max-width: 95%;\n  }\n  \n  .segment, .segment-active {\n    padding: 10px 8px;\n    font-size: 0.85rem;\n  }\n}\n\n@media (max-width: 600px) {\n  .weight-update-page {\n    padding: 20px 0;\n    width: 90%;\n    max-width: 100%;\n    box-sizing: border-box;\n    margin: 0 auto;\n  }\n  .weight-container {\n    width: 90%;\n    margin: 0 auto;\n  }\n  .diet-page {\n    padding: 20px 10px;\n    overflow-x: hidden;\n    width: 90%;\n    box-sizing: border-box;\n    margin: 0 auto;\n  }\n  .segmented-control {\n    width: 95%;\n  }\n  .diet-container {\n    width: 100%;\n    margin: 20px auto;\n    margin-bottom: 60px;\n  }\n  .diet-type-selector select {\n    width: 50%;\n  }\n}\n\n.diet-date {\n  color: #666;\n  font-size: 0.9rem;\n  margin-top: -10px;\n  margin-bottom: 20px;\n  font-style: italic;\n}\n\n/* .diet-content {\n  white-space: pre-line;\n  text-align: left;\n  padding: 0 20px;\n} */\n\n.diet-html-content {\n  text-align: left;\n  padding: 0;\n  white-space: pre-wrap;\n  line-height: 1.6;\n  font-weight: 500;\n  font-size: 1.1rem;\n}\n\n.diet-html-content p {\n  margin-bottom: 1em;\n}\n\n.diet-html-content strong {\n  font-weight: bold;\n}\n\n.diet-html-content em {\n  font-style: italic;\n}\n\n.diet-html-content u {\n  text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
